import type { OperatingDay, OperatingShift } from "@arena/shared";

type ShiftSource = { shifts?: OperatingShift[]; opensAt?: string | null; closesAt?: string | null };

/** Keep explicit empty arrays empty; only historical responses use the legacy pair. */
export function editableShifts(source?: ShiftSource): OperatingShift[] {
  if (source?.shifts) return source.shifts.map((shift) => ({ ...shift }));
  if (source?.opensAt && source.closesAt) return [{ opensAt: source.opensAt.slice(0, 5), closesAt: source.closesAt.slice(0, 5) }];
  return [];
}

export function validateShifts(shifts: OperatingShift[], label = "Neste dia"): OperatingShift[] {
  if (!shifts.length) throw new Error(`${label}: adicione pelo menos um turno ou marque como fechado.`);
  const clock = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  for (const shift of shifts) {
    if (!clock.test(shift.opensAt) || !clock.test(shift.closesAt)) throw new Error(`${label}: preencha a abertura e o fechamento de todos os turnos.`);
    if (shift.closesAt <= shift.opensAt) throw new Error(`${label}: cada turno deve fechar depois da abertura, no mesmo dia.`);
  }
  const sorted = shifts.map((shift) => ({ ...shift })).sort((a, b) => a.opensAt.localeCompare(b.opensAt));
  if (sorted.some((shift, index) => index > 0 && shift.opensAt < sorted[index - 1]!.closesAt)) throw new Error(`${label}: os turnos não podem se sobrepor.`);
  return sorted;
}

export function weeklyShiftPayload(days: OperatingDay[], labels: string[]) {
  if (days.length !== 7 || new Set(days.map((day) => day.weekday)).size !== 7 || days.some((day) => !Number.isInteger(day.weekday) || day.weekday < 0 || day.weekday > 6)) throw new Error("Informe os sete dias da semana.");
  return days.map((day) => ({ weekday: day.weekday, open: day.open, shifts: day.open ? validateShifts(editableShifts(day), labels[day.weekday]) : [] }));
}

export function shiftSummary(source: ShiftSource) {
  return editableShifts(source).map((shift) => `${shift.opensAt} às ${shift.closesAt}`).join(" · ");
}
